// Global retailers where the book will be available.
// Links use retailer search for "The Love Genome" until direct product URLs are provided.
const Q = encodeURIComponent("The Love Genome Felicia Johnson");
export const RETAILERS = [
  { key: "amazon", label: "Amazon", url: `https://www.amazon.com/s?k=${Q}` },
  { key: "barnes", label: "Barnes & Noble", url: `https://www.barnesandnoble.com/s/The%20Love%20Genome` },
  { key: "forbes", label: "Forbes Books", url: "https://books.forbes.com/" },
  { key: "apple", label: "Apple Books", url: "https://books.apple.com/us/genre/books/id38" },
  { key: "google", label: "Google Play Books", url: `https://play.google.com/store/search?q=${Q}&c=books` },
  { key: "bookshop", label: "Bookshop.org", url: `https://bookshop.org/search?keywords=The%20Love%20Genome` },
  { key: "kobo", label: "Rakuten Kobo", url: `https://www.kobo.com/us/en/search?query=The%20Love%20Genome` },
  { key: "walmart", label: "Walmart", url: `https://www.walmart.com/search?q=The%20Love%20Genome` },
  { key: "target", label: "Target", url: `https://www.target.com/s?searchTerm=The%20Love%20Genome` },
];
